import { AccountOrderContract } from "./account-order";
import { AttributeContract } from "./attribute";
import { BackgroundFailureContract } from "./background-failure";
import { BundleContract } from "./bundle";
import { CartContract } from "./cart";
import { CategoryContract } from "./category";
import { CheckoutContract } from "./checkout";
import { CompanyDetailsContract } from "./company-details";
import { ContactMessageContract } from "./contact-message";
import { CustomerContract } from "./customer";
import { CustomerAccountContract } from "./customer-account";
import { CustomerAddressContract } from "./customer-address";
import { DiscountCodeContract } from "./discount-code";
import { EmployeeContract } from "./employee";
import { FaqItemContract } from "./faq-item";
import { HealthContract } from "./health";
import { HolderContract } from "./holder";
import { InvoiceContract } from "./invoice";
import { NewsletterContract } from "./newsletter";
import { OrderContract } from "./order";
import { PageContract } from "./page";
import { PaymentContract } from "./payment";
import { PersonalAccessTokenContract } from "./personal-access-token";
import { PriceContract } from "./price";
import { ProductContract } from "./product";
import { ProductLineContract } from "./product-line";
import { ProductReviewContract } from "./product-review";
import { ProductReviewAdminContract } from "./product-review-admin";
import { RefundContract } from "./refund";
import { ReorderContract } from "./reorder";
import { RevenueContract } from "./revenue";
import { SessionContract } from "./session";
import { ShippingRuleContract } from "./shipping-rule";
import { ShopCatalogContract } from "./shop-catalog";
import { StockContract } from "./stock";
import { WorkQueueContract } from "./work-queue";

/**
 * The oRPC contract: the one description of the API, read by the web app's client and by the API
 * (which validates with the same Zod schemas, see `apps/api/src/platform/contract-schema.ts`).
 *
 * One file per area (`./<area>.ts`, exporting `<Area>Contract`), and one line per area below,
 * sorted. Every procedure declares `.route({ method, path })`, its path relative to `/api`.
 * `apps/api/tests/contract.test.ts` fails when a procedure has no matching endpoint.
 */
export const contract = {
	accountOrder: AccountOrderContract,
	attribute: AttributeContract,
	backgroundFailure: BackgroundFailureContract,
	bundle: BundleContract,
	cart: CartContract,
	category: CategoryContract,
	checkout: CheckoutContract,
	companyDetails: CompanyDetailsContract,
	contactMessage: ContactMessageContract,
	customer: CustomerContract,
	customerAccount: CustomerAccountContract,
	customerAddress: CustomerAddressContract,
	discountCode: DiscountCodeContract,
	employee: EmployeeContract,
	faqItem: FaqItemContract,
	health: HealthContract,
	holder: HolderContract,
	invoice: InvoiceContract,
	newsletter: NewsletterContract,
	order: OrderContract,
	page: PageContract,
	payment: PaymentContract,
	personalAccessToken: PersonalAccessTokenContract,
	price: PriceContract,
	product: ProductContract,
	productLine: ProductLineContract,
	productReview: ProductReviewContract,
	productReviewAdmin: ProductReviewAdminContract,
	refund: RefundContract,
	reorder: ReorderContract,
	revenue: RevenueContract,
	session: SessionContract,
	shippingRule: ShippingRuleContract,
	shopCatalog: ShopCatalogContract,
	stock: StockContract,
	workQueue: WorkQueueContract,
};

export { Cents } from "./money";
